
// src/pages/client/BlogArticle.jsx
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';
import { getArticleBySlug } from '../../data/blogArticles';
// Import du CSS spécifique pour les articles de blog
import '../../styles/blog.css';

const BlogArticle = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const article = getArticleBySlug(slug);

  if (!article) {
    return (
      <div className="min-h-screen bg-slate-100">
        <ClientNavbar />
        <div className="pt-20 pb-16 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-slate-800 mb-4">Article non trouvé</h1>
            <button 
              onClick={() => navigate('/blog')}
              className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition"
            >
              Retour au blog
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100">
      <ClientNavbar />
      
      {/* Hero Article */}
      <div className="pt-20 pb-12 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="flex items-center justify-center mb-4">
              <span className="bg-indigo-500 text-white text-sm px-3 py-1 rounded-full">
                {article.category}
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {article.title}
            </h1>
            <p className="text-xl text-slate-300 mb-8 max-w-3xl mx-auto">
              {article.excerpt}
            </p>
            <div className="flex items-center justify-center text-slate-400 text-sm">
              <span>Par {article.author}</span>
              <span className="mx-2">•</span>
              <span>{article.date}</span>
              <span className="mx-2">•</span>
              <span>{article.readTime} de lecture</span>
            </div>
          </div>
        </div>
      </div>

      {/* Article Content */}
      <div className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
              {/* Article Body avec la nouvelle classe CSS */}
              <div 
                className="blog-article-content"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />
              
              {/* Share Buttons */}
              <div className="mt-12 pt-8 border-t border-slate-200">
                <h4 className="text-lg font-semibold text-slate-800 mb-4">
                  Partager cet article
                </h4>
                <div className="flex space-x-4">
                  <button 
                    onClick={() => {
                      const url = window.location.href;
                      const text = `${article.title} - ${article.excerpt}`;
                      window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
                    }}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition text-sm"
                  >
                    LinkedIn
                  </button>
                  <button 
                    onClick={() => {
                      const url = window.location.href;
                      const text = `${article.title} - ${article.excerpt}`;
                      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank');
                    }}
                    className="bg-slate-600 text-white px-4 py-2 rounded-lg hover:bg-slate-700 transition text-sm"
                  >
                    Twitter
                  </button>
                  <button 
                    onClick={() => {
                      const subject = article.title;
                      const body = `Je vous recommande cet article : ${article.title}\n\n${article.excerpt}\n\nLire l'article complet : ${window.location.href}`;
                      window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
                    }}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition text-sm"
                  >
                    Email
                  </button>
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div className="mt-8 flex justify-between items-center">
              <button 
                onClick={() => navigate('/blog')}
                className="bg-slate-600 text-white px-6 py-3 rounded-lg hover:bg-slate-700 transition flex items-center"
              >
                ← Retour au blog
              </button>
              <button 
                onClick={() => navigate('/contact')}
                className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition"
              >
                Essayer Jobrise →
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BlogArticle;